import Repository from '../Repository';
const resource = '/dp/top';

export default {
  getList() {
    return Repository.get(`${resource}`);
  }
};
